import React from "react";

const AiPower = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5 10.4376V25.0001C27.5 25.6631 27.2366 26.299 26.7678 26.7678C26.2989 27.2367 25.663 27.5001 25 27.5001H5C4.33696 27.5001 3.70107 27.2367 3.23223 26.7678C2.76339 26.299 2.5 25.6631 2.5 25.0001V10.4376C2.50201 9.93899 2.65305 9.45241 2.9337 9.04034C3.21436 8.62827 3.61181 8.30952 4.075 8.12505L14.075 4.12505C14.669 3.88849 15.331 3.88849 15.925 4.12505L25.925 8.12505C26.3882 8.30952 26.7856 8.62827 27.0663 9.04034C27.347 9.45241 27.498 9.93899 27.5 10.4376Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 22.5H22.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 17.5H22.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 12.5H7.5V27.5H22.5V12.5Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AiPower;
